import './App.css';
import {useState,useEffect} from 'react'
import { Navbar } from './components/NavBar/Navbar';
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import { Home } from './Home';
import { Cocktail } from './Cocktail';
import { Favourite } from './Favourite';


function App() {
  const [cocktail,setCocktail] = useState([])
  const [text,setText] = useState('')
  const [singleCocktail,setSingleCocktail]=useState([]);



const showId = (id) =>{
  // console.log(cocktail[id])
setSingleCocktail(cocktail[id])
}

  

// cocktail fetch
const fetchCocktail = async()=>{
  const API = `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${text}` 
  const response = await fetch(API);
  const data = await response.json()
  if(data?.lenght <1)return  setCocktail(0)

  setCocktail(data.drinks)
}

//submit function 
const handleSubmit = (e) =>{
  e.preventDefault();
  fetchCocktail();
  setText('')
  setCocktail('')
  e.target.reset()
}

//list all saved cocktail
const fetchDatabase = async()=>{
  const cocktailAPI = `https://cokctail.herokuapp.com/drinks` 
  const response = await fetch(cocktailAPI);
  const data = await response.json()
  console.log(data.payload,'app.js')
}
useEffect(()=>{
  fetchDatabase();
},[])
//


  return (

    <div className="App ">

  <BrowserRouter>
  <Navbar/>
    <Routes>
      <Route path='/' element={<Home cocktail={cocktail} setCocktail={setCocktail} tetx={text} setText={setText} fetchCocktail={fetchCocktail} handleSubmit={handleSubmit} showId={showId}/>}/>
      <Route path='/cocktail' element={<Cocktail cocktail={cocktail} setCocktail={setCocktail} tetx={text} setText={setText} fetchCocktail={fetchCocktail} singleCocktail={singleCocktail}/>}/>
      <Route path='/favourite' element={<Favourite/>}/>
    </Routes>
  </BrowserRouter>

    </div>
    
  );
}

export default App;
